import type { OptimisticState } from 'redux-optimistic-ui';
import type { EntitiesState } from '../../reducers/entities/types';
import type { State } from '../../types';

export const hasAnyActiveOptimistic = (state: State): boolean => {
	const beforeState =
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		state.entities && (state.entities as OptimisticState<EntitiesState>).beforeState;
	return beforeState !== undefined;
};
